// Separate from api/cart.ts and types/cart.ts to avoid a circular dependency —
// api/ imports this schema to call .parse(); types/ re-exports the inferred type.

import { z } from 'zod'

const CalculationResponseTotalsSchema = z
	.object({
		grandTotal: z.number(),
		// TODO: declare subtotal, tax, serviceCharge, fees once confirmed against staging in P2-S3-08
	})
	.passthrough()

export const CalculationResponseSchema = z.object({
	totals: CalculationResponseTotalsSchema,
	// tips is a Record keyed by percentage label (e.g. 'tip15') with cent values, or null
	// when no tip options are configured for the location.
	// Ember: ticket.js:148 — Object.entries(this.get('calculations.tips')).sort()
	tips: z.record(z.string(), z.number()).nullable(),
	// TODO: P2-S5-04 — activeCouponCode: z.string().optional()  (ticket.js:193)
	// TODO: P2-S5-04 — discounts: z.array(z.object({ discountRef: z.string(), source: z.string() }))  (ticket.js:489)
})

// CalculationResponse is inferred from the schema — the schema is the single source of truth.
// types/cart.ts re-exports this type so consumers (ticketSlice.ts) import from types/cart.ts unchanged.
export type CalculationResponse = z.infer<typeof CalculationResponseSchema>
